import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPipe } from './search.module';
import { OwnerSearchPipe } from './ownerSearch.module';
import { InquirySearchPipe } from './InquirySearch.module';
import { NotPassSearchPipe } from './notPassSearch.module';
import { OrderSearchPipe } from './orderSearch.module';
import { UserTypeSearchPipe } from './userTypeSearch.module';
import { PaidSearchPipe } from './paid-search.pipe';

@NgModule({
  declarations: [SearchPipe, OwnerSearchPipe, InquirySearchPipe, NotPassSearchPipe, OrderSearchPipe, UserTypeSearchPipe, PaidSearchPipe],
  imports: [CommonModule],
  exports: [SearchPipe, OwnerSearchPipe, InquirySearchPipe, NotPassSearchPipe, OrderSearchPipe, UserTypeSearchPipe, PaidSearchPipe],
})
export class PipeModule {}
